/*******************************************************************************
  설  명 : 홈페이지 > 컨텐츠 표시
  작성자 : 송영석
  작성일 : 2020-06-05
*******************************************************************************/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService } from '@app/service/common.service';
import { UtilService } from '@app/service/util.service';
import { AhriService } from '@app/service/ahri.service';

import { ToastrService } from 'ngx-toastr';

import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

@Component({
  selector: 'app-home-ahri',
  templateUrl: './home-ahri.component.html',
  styleUrls: ['./home-ahri.component.scss']
})
export class HomeAhriComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  public menu: any;
  public active_seq = '';

  public tabIndex: any = 0;

  ahriList: any = [];

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private ahriService: AhriService
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit(): void {
    this.getAhriList();

    this.currMenu$.subscribe( ( menu: any ) => {
      if( typeof menu['seq'] == 'undefined' ) return false;

      const page = ( menu.page_cd ) ? menu.page_cd : '0';

      switch (page.length) {
        case 12:
          this.active_seq = menu.parentNode.seq;
          this.menu = menu.parentNode;
          break;
        default:
          this.active_seq = menu.seq;
          this.menu = menu;
          break;
      }

    });
  }

  /*******************************************************************************
    설  명 : 리스트 데이터 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getAhriList() {
    let search: any = {
      searchText: ''
    }
    this.ahriService.getAhriList(search).then( response => {
      if( response.ResultCode ) {
        this.ahriList = response.data;
      }
    })
  }

  /*******************************************************************************
    설  명 : 서브메뉴 링크
    입력값 : item = 메뉴 array
    리턴값 : 없음
  *******************************************************************************/
  goLink( menu ) {

    let href = menu.link_url;
    let boardId = menu.board_id;
    let menuIndex = menu.seq;

    if (href === '') {
      let result = false;
      const link = function getURL(item) {
        if (item.link_url === '' && item.board_id === '') {
          for (const element of item.children) {
            getURL(element);
            if (result) {
              return false;
            }
          }
        } else {
          href = item.link_url;
          boardId = item.board_id;
          menuIndex = item.seq;
          result = true;
        }
      };
      link(menu);
    }

    if ( boardId === '' ) {
      this.router.navigate([ href ], { queryParams: { menu_seq: menuIndex }});
    } else {
      this.router.navigate([ (href !== '' ? href : '/board/list') ], { queryParams: { board_id: boardId } });
    }
  }

}
